import React from 'react';
import {
  Col, Container, Row,
} from 'react-bootstrap';

import Accordion from 'components/Accordion';
import Checkbox from 'components/DesignSystem/Checkbox';
import useAcomphMLT from 'utils/hooks/flux/automatic/useAcomphMLT';

export default function AcomphMLT() {
  const {
    acomph, onAcomphChange, mlt, onMltChange,
  } = useAcomphMLT();

  return (
    <Accordion.Item eventKey="3">
      <Accordion.Header>Incluir ACOMPH/MLT</Accordion.Header>
      <Accordion.Body>
        <Container>
          <Row md={12}>
            <Col>
              <Checkbox
                label="ACOMPH (ENA verificada)"
                onChange={onAcomphChange}
                checked={acomph}
              />
            </Col>
          </Row>
          <Row md={12}>
            <Col>
              <Checkbox
                label="MLT (média mensal de referência)"
                onChange={onMltChange}
                checked={mlt}
              />
            </Col>
          </Row>
        </Container>
      </Accordion.Body>
    </Accordion.Item>
  );
}
